import {BaseCriteriaModel} from '../base-criteria.model';
import {Optional} from 'typescript-optional';

export class StockTakeSessionDeviceQueryCriteriaClass extends BaseCriteriaModel {
  sessionGuid?: Optional<string> = Optional.empty();
  deviceId?: Optional<string> = Optional.empty();
  deviceDescription?: Optional<string> = Optional.empty();
  loginGuid?: Optional<string> = Optional.empty();

}

export class StockTakeSessionDeviceCriteriaModelQuery {
  query = '';

  constructor(stockTakeSessionDeviceCriteriaModel: StockTakeSessionDeviceQueryCriteriaClass) {

    if (!stockTakeSessionDeviceCriteriaModel) {
      return;
    }
    
    this.query += stockTakeSessionDeviceCriteriaModel.sessionGuid.filter(x => x !== '').map(x => '&session_guid=' + x).orElse('');
    this.query += stockTakeSessionDeviceCriteriaModel.deviceId.filter(x => x !== '').map(x => '&device_id=' + x).orElse('');
    this.query += stockTakeSessionDeviceCriteriaModel.deviceDescription.filter(x => x !== '').map(x => '&device_description=' + x).orElse('');
    this.query += stockTakeSessionDeviceCriteriaModel.loginGuid.filter(x => x !== '').map(x => '&login_guid=' + x).orElse('');

    //this.query += '&status=' + stockTakeSessionDeviceCriteriaModel.status;
    this.query += '&orderBy=' + stockTakeSessionDeviceCriteriaModel.orderBy;
    this.query += '&order=' + stockTakeSessionDeviceCriteriaModel.order;
    this.query += '&offset=' + stockTakeSessionDeviceCriteriaModel.offset + '&limit=' + stockTakeSessionDeviceCriteriaModel.limit;
  }
}
